module.exports = __webpack_public_path__ + "img/pro_rc_00.a95f8da9.png";